<i18n src="./resources/locales.json"></i18n>

<template>
  <v-card
    v-if="showCard"
    class="contact-card elevation-2"
    :style="CSS_VARS"
    @mouseenter.stop="keepOpen"
    @mouseleave.stop="syncClose"
  >
    <v-list color="surface lighten-1" two-line>
      <v-list-item v-for="phone in phoneList" :key="phone.id" @click="select(phone.value)">
        <v-list-item-content>
          <v-list-item-title>
            {{ phone.value }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ phone.description }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsContactMixin from '@/mixins/ecs-contact-mixin/EcsContactMixin';
import EcsState from '@/components/ecs-agent-state/EcsState';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default {
  name: 'EcsContactPhoneSelectorPopUp',

  components: {},

  mixins: [EcsContactMixin],

  data() {
    return {
      show: false,
      position: {
        x: null,
        y: null
      },
      closeTimeoutRef: null,
      contact: null,
      action: null
    };
  },

  computed: {
    ...mapGetters('SETTINGS', ['isOfflineModeEnabled']),
    ...mapGetters('CONTACTS', ['getAvailabilityState']),

    phoneList() {
      return [...this.contact.phones, ...this.contact.mobiles];
    },

    isAgent() {
      return [CONTACT_TYPE.agent, CONTACT_TYPE.supervisor, CONTACT_TYPE.enterprise].includes(this.contact.contactType);
    },

    agentState() {
      return new EcsState(this.getAvailabilityState(this.contact.id));
    },

    agentStateDisplayName() {
      return this.agentState.isBreak && !this.agentState.isNoAnswer
        ? `${this.$t('break')} &bullet; ${this.agentState.reasonCode || this.agentState.stateName}`
        : this.agentState.stateName;
    },

    getNumberOfContacts() {
      return this.contact.isSMSEnabled ? [...this.contact.mobiles, ...this.contact.phones] : [];
    },

    CSS_VARS() {
      return {
        '--top': `${this.position.y}px`,
        '--left': `${this.position.x}px`,
        '--display': this.show ? 'block' : 'none'
      };
    },

    showCard() {
      return this.contact && this.show;
    },

    emailActionDisabled() {
      return this.isOfflineModeEnabled || !this.contact.isEmailEnabled;
    }
  },

  created() {
    this.$root.$on('open-contact-phone-selector-card', this.open);
    this.$root.$on('close-contact-phone-selector-card', this.close);
  },

  beforeDestroy() {
    this.$root.$off('open-contact-phone-selector-card', this.open);
    this.$root.$off('close-contact-phone-selector-card', this.close);
  },

  methods: {
    ...mapActions('CONTACTS', ['addToFavoriteContacts', 'removeFromFavoriteContacts']),

    keepOpen() {
      clearTimeout(this.closeTimeoutRef);
    },

    open({ contact, x, y, action }) {
      this.contact = contact;
      this.action = action;
      this.position.x = x;
      this.position.y = y;
      this.show = true;
      clearTimeout(this.closeTimeoutRef);
    },

    syncClose() {
      clearTimeout(this.closeTimeoutRef);
      this.contact = null;
      this.show = false;
    },

    close() {
      this.closeTimeoutRef = setTimeout(() => {
        this.contact = null;
        this.show = false;
      }, 300);
    },

    select(phone) {
      this.action(phone);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-card {
  background-color: var(--v-surface-lighten1);
  position: absolute;
  top: var(--top);
  left: var(--left);
  display: var(--display);
  z-index: 1000;
  overflow: hidden;
  width: 180px;
}

.ecs-item-avatar {
  margin-right: 10px;
}

.ecs-contact-item-action-icon:not(:first-child) {
  margin-left: 15px;
}

.ecs-contact-item-action-btn.theme--light.v-btn--disabled .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.ecs-contact-item-action-btn.theme--dark.v-btn--disabled .v-icon {
  color: #ffffff !important;
}
</style>
